<template>
  <div class="loader"></div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import '~style/variables';

$_radius: 10em;
$_color: #fff;
$_opacity: 0.2;
$_color-trans: rgba($_color, $_opacity);

.loader,
.loader:after {
  border-radius: 50%;
  width: $_radius;
  height: $_radius;
}
.loader {
  animation: load8 1.1s infinite linear;
  border-top: 1.1em solid;
  border-right: 1.1em solid;
  border-bottom: 1.1em solid;
  border-left: 1.1em solid $_color;
  color: $_color-trans;
  font-size: 2px;
  margin: 0 auto;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
}
@-webkit-keyframes load8 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.btn {
  > .loader {
    display: inline-block;
    vertical-align: middle;
  }
  &.inv, &.link {
    > .loader {
      border-left-color: $c-info;
      color: rgba($c-info, $_opacity);
    }
  }
  &.disabled {
    > .loader {
      border-left-color: $c-text-lightish;
      color: rgba($c-text-lightish, $_opacity);
    }
  }
}

.splash {
  > .loader {
    border-left-color: $c-info;
    color: rgba($c-info, $_opacity);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Loader.vue